import { downloadBlob } from '~/libs/downloadBlob'

/**
 * バイト列 (XML / ZIP など、 API が返したファイル) をブラウザのファイルダウンロードとして保存する
 * 副作用ヘルパー。 ファイル名はレスポンスの fileName を使い、保存は downloadBlob に任せる。
 *
 * content (Uint8Array) は subarray の view の可能性があり、 .buffer を直接渡すと
 * byteOffset / byteLength を無視して余分な byte を取り込みファイルが壊れる。 新しい Uint8Array に
 * コピーして view の論理内容 (offset / length) だけを渡す。
 */
export const downloadBytes = (
  content: Uint8Array,
  contentType: string,
  fileName: string,
): void => {
  downloadBlob(
    fileName,
    new Blob([new Uint8Array(content)], { type: contentType }),
  )
}
